import { Ng2StateDeclaration, UIRouterModule } from '@uirouter/angular';
import { Component } from '@angular/core';
import { StateService } from '@uirouter/core';
import { PipeService } from '@client/app/filters/pipe-transformation.service';
import { ActiveFeatureService } from '@monsido/services/active-feature/active-feature.service';
import {
    MonUIRouterTransitionService,
} from '@monsido/services/ui-router-transition-service/ui-router-transition-service';
import { GlobalPolicyDashboardComponent } from '@client/app/pages/global/policy/global-policy-dashboard.component';
import { GlobalPolicyPoliciesComponent } from '@client/app/pages/global/policy/policies/policies.component';
import { ChatBotComponent } from '@client/app/modules/chat-bot/components/chat-bot/chat-bot.component';


@Component({
    selector: 'base-global-policy',
    template: `<ui-view name="content"></ui-view>`,
    standalone: true,
    imports: [UIRouterModule],
})
class BaseGlobalPolicyComponent {}

export const GLOBAL_POLICY_STATES: Ng2StateDeclaration[] = [
    {
        name: 'base.customer.global.policy',
        url: '/policies',
        abstract: true,
        views: {
            'content@base.customer.global': {
                component: BaseGlobalPolicyComponent,
            },
        },
        data: {
            topmenu: 'policy',
            title: 'Acquia Web Governance - Summary',
        },
        resolve: [
            {
                token: 'isPolicyActive',
                deps: [
                    PipeService,
                    StateService,
                    ActiveFeatureService,
                    MonUIRouterTransitionService,
                ],
                resolveFn: async (
                    ng2PipeService: PipeService,
                    $state: StateService,
                    ng2ActiveFeatureService: ActiveFeatureService,
                    ng2MonUIRouterTransitionService: MonUIRouterTransitionService,
                ) => {
                    const validate = ng2PipeService.get('activeFeature')('global_policy');
                    if (!ng2ActiveFeatureService.isFeatureActivePure('policies_all') || !validate) {
                        ng2MonUIRouterTransitionService.onTransitionFinished(
                            () => {
                                $state.go('base.dashboard');
                            },
                        );
                    }
                    return Promise.resolve(true);
                },

            },
        ],
    },
    {
        name: 'base.customer.global.policy.dashboard',
        url: '/summary',
        views: {
            'content@base.customer.global.policy': {
                component: GlobalPolicyDashboardComponent,
            },
        },
        data: {
            title: 'Acquia Web Governance - Global Policies',
        },
    },
    {
        name: 'base.customer.global.policy.policies',
        url: '/list?search',
        views: {
            'content@base.customer.global.policy': {
                component: GlobalPolicyPoliciesComponent,
            },
        },
        data: {
            title: 'Acquia Web Governance - Policy List',
        },
    },
    {
        name: 'base.customer.global.policy.bot',
        url: '/assistant',
        views: {
            'content@base.customer.global.policy': {
                component: ChatBotComponent,
            },
        },
        data: {
            title: 'Acquia Web Governance - Policy Assistant',
        },
        resolve: [{
            token: 'policyBotAccessValidation',
            deps: [
                StateService,
                ActiveFeatureService,
                MonUIRouterTransitionService,
            ],
            resolveFn: async (
                $state: StateService,
                ng2ActiveFeatureService: ActiveFeatureService,
                ng2MonUIRouterTransitionService: MonUIRouterTransitionService,
            ) => {
                if (!ng2ActiveFeatureService.isFeatureActivePure('policy_bot')) {
                    ng2MonUIRouterTransitionService.onTransitionFinished(
                        () => {
                            $state.go('base.dashboard');
                        },
                    );
                }
                return Promise.resolve(true);
            },
        }],

    },
];
